import { Component, Input, OnInit } from '@angular/core';
/**
  Componente que muestra una advertencia o mensaje de alerta durante el proceso de check-in.
  Este componente permite mostrar un mensaje de advertencia junto con una imagen asociada,
  útil para notificar al usuario sobre situaciones importantes durante el check-in.
**/
@Component({
    selector: 'app-am-warning-check-in',
    templateUrl: './am-warning-check-in.component.html',
    styleUrls: ['./am-warning-check-in.component.scss'],
    standalone: false
})
export class AmWarningCheckInComponent implements OnInit {
  /**
    Texto de la advertencia que se mostrará al usuario.
    @type {string}
  **/
    @Input() textWarning: string;

    /**
      Ruta de la imagen que se mostrará junto con la advertencia.
      @type {string}
    **/
    @Input() imgWarning: string;
  constructor() { }

  ngOnInit(): void {
  }

}
